/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ main: NonNullable<unknown>, foreign: NonNullable<unknown> }} Snackbar_Mappingremoved1Inputs */

const en_snackbar_mappingremoved1 = /** @type {(inputs: Snackbar_Mappingremoved1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} successfully removed from ${i?.foreign}.`)
};

const de_snackbar_mappingremoved1 = /** @type {(inputs: Snackbar_Mappingremoved1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} wurde erfolgreich von ${i?.foreign} entfernt.`)
};

/**
* | output |
* | --- |
* | "{main} successfully removed from {foreign}." |
*
* @param {Snackbar_Mappingremoved1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const snackbar_mappingremoved1 = /** @type {((inputs: Snackbar_Mappingremoved1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_Mappingremoved1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_mappingremoved1(inputs)
	return de_snackbar_mappingremoved1(inputs)
});
export { snackbar_mappingremoved1 as "snackbar_mappingRemoved" }